import Vue from "vue";
import VueGlide from "@gedhean/vue-glide-js";

import "../cart/src/scss/main.scss";

import cart from "../cart/src/components/Cart.vue";
import cartSummary from "../cart/src/components/CartSummary.vue";
import loadingScreen from "../cart/src/components/LoadingScreen.vue";

import cartStore from "./stores/cart";

Vue.use(VueGlide);

new Vue({
    el: "#app",
    data: function () {
        return {
            cart: cartStore.state
        }
    },
    beforeMount: function () {
        cartStore.load();
    },
    components: {
        cart,
        cartSummary,
        loadingScreen
    }
});